import { getPublicApiBaseUrl } from "../api/convex";

const ALLOWED_IMAGE_HOSTS = ["cdninstagram.com", "fbcdn.net"];

export function proxiedImageUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;

  try {
    const parsed = new URL(url);
    const isAllowed = ALLOWED_IMAGE_HOSTS.some(
      (host) => parsed.hostname === host || parsed.hostname.endsWith(`.${host}`),
    );

    if (!isAllowed) return url;

    return `${getPublicApiBaseUrl()}/api/v1/image?${new URLSearchParams({
      url,
    }).toString()}`;
  } catch {
    return url;
  }
}
